import * as types from './types';

export const toggleLasso = () => {
  return {
    type: types.TOGGLE_LASSO,
  };
};

export const toggleBlockOnClick = () => {
  return {
    type: types.TOGGLE_BLOCK_ON_CLICK,
  };
};



// WEBPACK FOOTER //
// ./src/common/Components/LassoSelection/state/actions.js